import { getModuleContent } from '@home/services/studio';
import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'umi';

interface IProps {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  config: any;
  gameInfo?: { [key: string]: string; };
  filter: { [key: string]: string; };
  defaultList: IHighlightItem[];
  changeParams: Array<string>;
  filterCond: any;
  highlightCnMap: Record<string, string>;
}

interface IHighlightItem {
  key: string;
  titleEn: string;
  titleCn: string;
  executive_summary: string;
  
}

export default function Insights(props: IProps) {
  const { className, style, children, filter, gameInfo, ...restProps } = props || {};
  const { date_type: dateType, start_time: startTime, end_time: endTime, game } = filter || {};
  const languageRef = useRef(filter.language);
  const { formatMessage } = useIntl();

  const [insightsData, setInsightsData] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editModalTitle, setEditModalTitle] = useState(formatMessage({id: 'dbh_studio_edit_insights'}));

  // Insights数据获取
  const getInsightsData = async () => {
    const params = {
      system: "studio_hub",
      type: 2,
      uid_type: "unified_id,comp_unified_id",
      uid: `${gameInfo?.edition_unified_id},${game}`,
      period: dateType,
      start_time: startTime,
      end_time: endTime,
      module: "insights",
      status: 1,
    };
  
    try {
      setLoading(true);
      const data = await getModuleContent(params);
      setInsightsData(data?.[0]);
      setError(false);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    if (!game) {
      return;
    }
  
    if (filter.language !== languageRef.current) {
      // 仅更新 languageRef，不触发 getInsightsData
      languageRef.current = filter.language;
      return;
    }
  
    getInsightsData();
  }, [filter, game, gameInfo]);

  return (
    <>
      {React.Children.map(children, (child: any) => React.cloneElement(
        child,
        {
          className,
          showModal,
          setShowModal,
          insightsData,
          setInsightsData,
          loading,
          error,
          filter,
          getInsightsData,
          gameInfo,
          editModalTitle,
          setEditModalTitle,
          ...restProps,
        }
      ))}
    </>
  );
}